import mixpanel from "mixpanel-browser";

import { whooshPatronUserIdentityForExternalTools } from "@/hooks/useIdentifyUserToExternalTools/types";
import { getExpoEASConstant } from "@/utils/expoConstants";

import { isAnalyticsTrackingAllowed } from "../../analyticsTrackingConsent";
import { validMixpanelEnvs } from "../../types";
import { initializeMixpanel } from "../useInitializeMixpanel/useInitializeMixpanel";

export const identifyUserToMixpanel = (
  user: whooshPatronUserIdentityForExternalTools
) => {
  const env = getExpoEASConstant("deployEnv");
  if (isAnalyticsTrackingAllowed() && validMixpanelEnvs.includes(env)) {
    initializeMixpanel();
    mixpanel.identify(user.userId);
    mixpanel.people.set({
      $name: user.name,
      $email: user.email,
    });
  }
};
